import { MapContext } from 'components/maps/MapContext';
import { useContext } from 'react';
import { getIconFromCache } from '../../utils';
import { renderToStaticMarkup } from 'react-dom/server';
import { CheckCircle } from '@mui/icons-material';
import { cyan } from '@mui/material/colors';

const MAX_CLUSTER_COUNT = 999;
const SELECTED_CACHE: { [key: string]: string } = {};

export const useMapMarkerIcon = () => {
  const { isEntitySelected, isAnyEntitySelected } = useContext(MapContext);
  const getSelectedMarkup = (iconHtml: string) => {
    const html = SELECTED_CACHE[iconHtml];
    if (html) {
      return html;
    }

    const renderHtml = renderToStaticMarkup(
      <div style={{ position: 'relative', width: 'auto', height: 'auto' }}>
        <div style={{ position: 'absolute', bottom: -4, zIndex: 99 }}>
          <CheckCircle
            sx={{
              width: 12,
              height: 12,
              background: 'black',
              color: cyan.A400,
              borderRadius: 25,
            }}
          />
        </div>
        <div dangerouslySetInnerHTML={{ __html: iconHtml }} />
      </div>
    );

    SELECTED_CACHE[iconHtml] = renderHtml;
    return renderHtml;
  };
  type IconData = {
    properties: { id: string; cluster: any; iconHtml: string; anchorX: number; anchorY: number };
    clusters: Record<string, { ids: string[]; count: number; svg: string }>;
  };
  const renderClusterGroup = (iconData: IconData, addToCache: (html: string) => void) => {
    let markerGroupHtml = '';

    Object.keys(iconData.clusters).forEach((key) => {
      const cluster = iconData.clusters[key];
      const count = cluster.count > MAX_CLUSTER_COUNT ? `${MAX_CLUSTER_COUNT}+` : cluster.count;
      const isSelected = isAnyEntitySelected(cluster.ids);
      const selectedIconHtml = `<div class='clusterGroupSelected'>${
        isSelected ? checkMarkIcon : null
      }</div>`;

      markerGroupHtml =
        markerGroupHtml +
        `<div class='clusterGroup'>
          <div class='clusterGroupContentIcon'>${cluster.svg}</div>
          <div class='clusterGroupContentTotal'>${count}</div>
          ${isSelected ? selectedIconHtml : ''}
        </div>`;
    });
    const html = `<span class='groupContainer'>${markerGroupHtml}</span>`;
    return getIconFromCache(html, undefined, undefined, addToCache);
  };

  const getMarkerIcon = (iconData: IconData, addToCache: (html: string) => void) => {
    if (iconData.properties.cluster) {
      return renderClusterGroup(iconData, addToCache);
    }

    const { iconHtml } = iconData.properties;
    const iconMarkup = isEntitySelected(iconData.properties.id)
      ? getSelectedMarkup(iconHtml)
      : iconHtml;
    return getIconFromCache(
      iconMarkup,
      iconData.properties.anchorX,
      iconData.properties.anchorY,
      addToCache
    );
  };

  return { getMarkerIcon };
};

const checkMarkIcon = `<svg id="check_circle_black_24dp" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
<circle id="Ellipse_304" data-name="Ellipse 304" cx="7" cy="7" r="7" transform="translate(1 1)" fill="#fff"/>
<path id="Path_615" data-name="Path 615" d="M0,0H16V16H0Z" fill="none"/>
<path id="Path_616" data-name="Path 616" d="M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2ZM6.8,11l-3-3,.846-.846L6.8,9.3l4.554-4.554L12.2,5.6Z"/>
</svg>`;
